<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <v-expansion-panels class="pa-2">
          <v-expansion-panel
            v-for="(category, index) in computedValue.items"
            :key="index"
            class="mt-2 rounded-lg"
            @click="openDialog(index)"
          >
            <v-expansion-panel-header hide-actions>
              <v-btn
                :disabled="index === 0"
                class="me-2"
                icon
                max-width="32"
                @click.stop="moveUp(index)"
              >
                <v-icon>mdi-chevron-up</v-icon>
              </v-btn>

              <div>
                <!--            <img :src="category.picture" alt="" class="rounded-lg me-2"-->
                <!--                 style="object-fit: contain" width="48px">-->
                <div class="rowinfo">
                  <v-btn class="d-none d-md-inline-block contentinfo" outlined>
                    ویرایش دسته‌بندی {{ category.name }}
                  </v-btn>
                  <help-info
                    :element-name="`${serviceName}-${componentName}-edit-category-name`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="ویرایش دسته‌بندی"
                  />
                </div>

                <div class="d-md-none pt-2">
                  {{ category.name }}
                </div>
              </div>
              <v-spacer />
              <v-btn
                :disabled="index === computedValue.items.length - 1"
                icon
                max-width="32"
                @click.stop="moveDown(index)"
              >
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>

              <v-btn
                :loading="loading"
                icon
                max-width="36"
                @click.stop="deleteCat(index)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>

              <v-btn
                icon
                max-width="36"
                title="کپی دسته‌بندی"
                @click.stop="copyCat(category, index)"
              >
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
              <help-info
                v-if="index === -1"
                left
                :element-name="`${serviceName}-${componentName}-copy-category`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="فیلد"
              />
            </v-expansion-panel-header>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- Category Picker -->
        <insurance-category-picker
          v-model="catDialog"
          :items.sync="computedValue.items"
        />
        <!-- /Category picker -->

        <!-- Category Editor -->
        <insurance-editor
          v-model="editDialog"
          :categories="this.computedValue.items"
          :tabs.sync="editorTabs"
        />
        <!-- /Category Editor -->

        <v-card-actions class="px-2 pt-6">
          <div class="rowinfo" style="width: 100%">
            <v-btn
              color="success"
              outlined
              @click="catDialog = true"
              class="contentinfo"
            >
              <v-icon>mdi-plus</v-icon>
              افزودن دسته جدید
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-copy-category`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="افزودن دسته جدید"
            />
          </div>
        </v-card-actions>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../../pages/qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../pages/qrland/components/helpAcordion/HelpInfoWrapper.vue";
import InsuranceCategoryPicker from "@/view/components/pickers/insuranceCategoryPicker.vue";
import InsuranceEditor from "@/view/components/Insurance/insuranceEditor.vue";
import InsuranceContent from "@/utilities/InsuranceContent";
import { mapState } from "vuex";

export default {
  name: "InsuranceManage",

  components: {
    InsuranceEditor,
    InsuranceCategoryPicker,
    HelpInfo,
    HelpInfoWrapper,
  },

  props: {
    value: Object,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "insuraance-mange",
      catDialog: false,
      editDialog: false,
      editorTabs: 0,
      insuranceObject: new InsuranceContent(this.qr_id),
      loading: false,
    };
  },

  mounted() {
    this.fetchQrInsurance();
  },

  computed: {
    ...mapState("localstorage", ["createQrID"]),
    ...mapState("local", ["qr_id"]),
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    fetchQrInsurance() {
      this.loading = true;

      this.insuranceObject
        .qrInsurances(this.qr_id)
        .then(
          ({ data }) =>
            (this.computedValue.items = data.data.map((item) => item.category))
        )
        .finally(() => (this.loading = false));
    },
    openDialog(index) {
      this.editorTabs = index;
      this.editDialog = true;
    },
    moveDown() {},
    moveUp() {},
    copyCat() {},
    async deleteCat(index) {
      if (await this.$modal.yesNo("حذف دسته‌بندی مورد نظر؟")) {
        this.loading = true;

        this.insuranceObject
          .qrDeleteInsurance({
            qr_id: this.qr_id,
            category_id: this.computedValue.items[index].id,
          })
          .then(({ data }) => {
            this.computedValue.items = data.data.map((item) => item.category);
            this.$forceUpdate();
            this.$toast.success("دسته‌بندی مورد نظر با موفقیت حذف شد.");
          })
          .catch(({ response }) =>
            console.log("failed to delete qr insurance: ", response)
          )
          .finally(() => (this.loading = false));
      }
    },
    addCategory() {
      this.computedValue.items = [...this.computedValue.items];
    },
  },
};
</script>

<style scoped></style>
